import i18n from "@/plugins/i18n";
import type { StopInfoSeal } from "@/types/trip";
import { isSameEntity } from "@/utils/sameEntity";

const t = i18n.global.t;

class SealValidator {
  #seals;

  constructor(seals: StopInfoSeal[]) {
    this.#seals = seals;
  }

  validate(): Record<string, string | null> {
    return Object.fromEntries(
      this.#seals.map((seal) => {
        return [seal.tempId, this.#getError(seal)];
      }),
    );
  }

  #isEmpty(seal: StopInfoSeal) {
    return !seal.number.trim();
  }

  #isDuplicated(seal: StopInfoSeal): boolean {
    const number = seal.number.trim();

    const hasDuplicated = this.#seals.some((otherSeal) => {
      return (
        otherSeal.travelOrderId === seal.travelOrderId &&
        otherSeal.number.trim() === number &&
        !isSameEntity(otherSeal, seal)
      );
    });

    return hasDuplicated;
  }

  #getError(seal: StopInfoSeal): string | null {
    if (this.#isEmpty(seal)) {
      return t("trip.seal-number-required");
    }

    if (this.#isDuplicated(seal)) {
      return t("trip.seal-duplicate-on-travel-order", { id: seal.travelOrderId });
    }

    return null;
  }
}

export default SealValidator;
